import React from 'react'
import FuelReportFilter from './FuelReportFilter'
import '../../../styles/reports/reports-common.scss';

const FuelReport = () => {
  return (
    <div className="report--wrapper">
      <FuelReportFilter />
    </div>
  )
}

export default FuelReport
